import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-207" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance text-3xl font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-208" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
      <span className="mx-auto mt-4 flex w-fit items-center gap-1" aria-hidden="true" data-id="element-209" data-mp="mzgb791vxjxd">
        <span className="h-1 w-10 rounded-full bg-gold" data-id="element-210" data-mp="i6ww27njugqg" />
        <span className="h-1 w-3 rounded-full bg-celeste shadow-[0_0_10px_rgba(94,200,242,0.6)]" data-id="element-211" data-mp="d8v4szfyzb3w" />
      </span>
    </div>;
}